import { api } from '../core';
import { TOOLKIT_TAG } from '../constants';

export interface CreateSuggestedToolRequest {
  sourceToolId: string;
  collectionId: string;
  groupId: string;
  toolName: string;
  toolDescription: string;
  prompt: string;
  comments: string;
}

const createSuggestedToolApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createSuggestedTool: builder.mutation<void, CreateSuggestedToolRequest>({
      query: (body) => ({
        url: 'toolkit/create-suggested-tool',
        method: 'POST',
        body,
      }),
      invalidatesTags: [TOOLKIT_TAG],
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useCreateSuggestedToolMutation } = createSuggestedToolApi;
